module.exports = __webpack_public_path__ + "static/media/about.74d59dc1.jpg";